import { useCallback, useEffect } from 'react';
import { useFormState } from 'react-final-form';

const useUnsavedChanges = () => {
  const { dirty } = useFormState();

  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = '';
  }, []);

  useEffect(() => {
    if (dirty) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [dirty, handleBeforeUnload]);
};

export default useUnsavedChanges;
